import INavigationItem from '../../interfaces/navigation/navigationItem';

export const isFrontpage = (value, nodeValue) => {
	return value === '/frontpage' && nodeValue === '/';
};

export const findByValue = (value, key = '', children = '', originalStack = []) => {
	const stack = JSON.parse(JSON.stringify(originalStack));
	while (stack.length > 0) {
		const node = stack.pop();
		if (value === node[key] || isFrontpage(value, node[key])) {
			return node;
		}

		if (node[children] && node[children].length > 0) {
			for (let i = 0; i < node[children].length; ++i) {
				stack.push(node[children][i]);
			}
		}
	}

	return null;
};

export const getIdByUrl = (url, nav) => {
	const node = findByValue(url, 'Url', 'Children', nav);
	return node !== null ? node.Id : 0;
};

export const getPath = (curr: INavigationItem, breadcrumbs: INavigationItem[], id: number) => {
	let correctPath = false;

	curr.Children.map(child => {
		const childPath = getPath(child, breadcrumbs, id);
		if (childPath) correctPath = true;

		return null;
	});

	if (correctPath || curr.Id === id) {
		breadcrumbs.push(curr);
		correctPath = true;
	}

	return correctPath;
};
